import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"repeat"} maskId="square-filled-radius-0-stroke-1-IconRepeat"><path fillRule="evenodd" clipRule="evenodd" d="M2 3H22V19H12.7071L15.2071 21.5L14.5 22.2071L10.7929 18.5L14.5 14.7929L15.2071 15.5L12.7071 18H21V4H3V18H8V19H2V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRepeat;
